module.exports = __webpack_public_path__ + "static/media/rocket_blue.cdf449d8.svg";